import { create } from "zustand";

interface HookProps {
  open: boolean;
  onOpenChange: (bool: boolean) => void;
  sheetId: string | null;
  setSheetId: (id: string | null) => void;
  isCreatedFromCsv: boolean;
  setIsCreatedFromCsv: (bool: boolean) => void;
}

export const useCreateSalaryModal = create<HookProps>()((set) => ({
  open: false,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
  sheetId: null,
  setSheetId: (id) =>
    set(() => ({
      sheetId: id,
    })),
  isCreatedFromCsv: false,
  setIsCreatedFromCsv: (bool) =>
    set(() => ({
      isCreatedFromCsv: bool,
    })),
}));
